<template>
	<v-sheet flat>
        <render-content id="policies"></render-content>
	</v-sheet>
</template>

<script>
  import RenderContent from "@c/ui/RenderContent"
  export default {
    name: 'WbsitePolicies',
    components: {
      RenderContent
    },
  }
</script>
